


















































































import { Component, Vue, Prop } from 'vue-property-decorator';
import { User, Info, Device} from '@/types/core';

import VueError from '@/components/VueError.vue';
import Loading from '@/components/Loading.vue';
import LoraWanUpdateView from '@/components/LoraWanUpdateView.vue';
import CustomSectionHeader from '@/components/CustomSectionHeader.vue';
import TimestampAgo from '@/components/TimestampAgo.vue';
import DeliveryResponse from '@/components/subscriptions/DeliveryResponse.vue';
import { curNfreshClient, NfreshClient } from '@/services/NfreshClient';
import { Subscription, Delivery } from '@/types/core-push';
import NfreshDeliveryRow from '@/components/nfresh/NfreshDeliveryRow.vue';
import NfreshDeliveryRowMobile from '@/components/nfresh/NFreshDeliveryRowMobile.vue';

import moment from 'moment';
import tippy from 'tippy.js';


@Component({
  components:{
    VueError,
    Loading,
    LoraWanUpdateView,
    CustomSectionHeader,
    TimestampAgo,
    DeliveryResponse,
    NfreshDeliveryRow,
    NfreshDeliveryRowMobile
  }
})
export default class DeliveryList extends Vue {

  @Prop({ default: () => {},  type: Object}) sub!:Subscription;

  error:string = '';
  httpBusy:boolean = false;
  offset = 0;
  dbDeliveryList:Delivery[] = [];
  deliveryList:Delivery[] = [];
  
  showLoading:boolean = false;

  // internal dependencies
  private nfreshClient:NfreshClient = curNfreshClient;
    
  async mounted() {
    
    this.loadDeliveries();
  }

  async loadDeliveries() {

    this.showLoading = true;
    this.error = '';

    const reply = await this.nfreshClient.getSubDeliveries({subId: this.sub.subscriptionId, limit: 200});

    this.showLoading = false;

    if(reply.httpCode === 403)
      return this.$router.push({name:'login'});
    
    if(reply.errorMsg)
      return this.error = `Unable to retrieve latest deliveries for subscription ${this.sub.subscriptionId}: ${reply.errorMsg}`;

    this.dbDeliveryList = reply.deliveryList!;

    this.offset = 0;
    this.refreshDeliveryList();
  }

  refreshDeliveryList() {
    this.deliveryList = this.dbDeliveryList.slice(this.offset, this.offset+50);
  }

  goBack() {
    this.offset += 50;
    this.refreshDeliveryList();
  }

  goForward() {
    this.offset -= 50;
    this.refreshDeliveryList();
  }

  get showNav() { 
    return !this.showLoading && this.deliveryList.length > 0;
  }

  get showItemList() {
    return !this.showLoading && this.deliveryList.length > 0;
  }

  get showNoDeliveries() {
    return !this.showLoading && this.deliveryList.length === 0;
  }

  get olderItemsEnabled() {
    return this.dbDeliveryList.length > 50 && (this.offset + 50) < this.dbDeliveryList.length;
  }

  get newerItemsEnabled() {
    return this.dbDeliveryList.length > 50 && this.offset > 0;
  }

}

